import {
  ORIGIN_COUNT_COLUMNS,
  ORIGIN_RATE_COLUMNS,
} from './downloadReportCatalog';

const UTF8_BOM = '\uFEFF';

export const escapeCsvField = value => {
  const text = value == null ? '' : String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
};

export const originCsvFileName = (from, to) => {
  const safeFrom = String(from || '').replace(/:/g, '-');
  const safeTo = String(to || '').replace(/:/g, '-');
  return `origin-report-${safeFrom}-to-${safeTo}.csv`;
};

export const originCsvMetricCells = (metrics = {}) => {
  const cells = [metrics.orders ?? 0, metrics.amount ?? 0];
  ORIGIN_COUNT_COLUMNS.forEach(column => {
    cells.push(metrics[column] ?? 0);
    cells.push(metrics[`${column}_amount`] ?? 0);
  });
  const orders = Number(metrics.orders) || 0;
  const rate = status =>
    orders
      ? (((Number(metrics[status]) || 0) / orders) * 100).toFixed(1)
      : '0.0';
  ORIGIN_RATE_COLUMNS.forEach(column => {
    const status = {
      delivery_rate: 'delivered',
      return_rate: 'returned',
      cancelled_rate: 'cancelled',
    }[column];
    cells.push(rate(status));
  });
  return cells;
};

export const buildOriginCsv = ({
  headers = [],
  rows = [],
  totals = [],
} = {}) => {
  const lines = [
    headers.map(escapeCsvField).join(','),
    ...rows.map(row => row.map(escapeCsvField).join(',')),
  ];
  if (totals.length) {
    lines.push(totals.map(escapeCsvField).join(','));
  }
  return `${UTF8_BOM}${lines.join('\n')}`;
};

export const buildCsv = buildOriginCsv;
